export default "__VITE_ASSET__C84Qu$ZK__"